import { getRiskOptions } from '../../utils';
import * as Constants from '../../constants';

export const getEnvironmentalInformationSelectInputProps = (
  riskList,
  riskWatershedList,
  envAttributes,
  filter
) => {
  const environmentalInformationSelectInputProps = [];
  if (filter === null || filter === 'typePresence') {
    environmentalInformationSelectInputProps.push({
      propertyName: 'typePresence',
      label: 'inventory.details.page.environmental.inf.container.type.presence.input',
      options: getRiskOptions(
        riskList,
        Constants.RISK_TYPE_PRESENCE_TYPE_CODE,
        envAttributes['typePresence']
      )
    });
  }
  if (filter === null || filter === 'waterCourse') {
    environmentalInformationSelectInputProps.push({
      propertyName: 'waterCourse',
      label: 'inventory.details.page.environmental.inf.container.water.course.input',
      options: getRiskOptions(
        riskWatershedList,
        Constants.RISK_TYPE_WATERCOUSE_CODE,
        envAttributes['waterCourse'],
        ['watershed.watercourse', 'value'] // value contains 'watershed.code' but also the N/A translation code
      ),
      propUsedInChanges: 'watershed.watercourseAndCode',
      disabled: true
    });
  }
  if (filter === null || filter === 'containerInspection') {
    environmentalInformationSelectInputProps.push({
      propertyName: 'containerInspection',
      label: 'inventory.details.page.environmental.inf.container.container.inspection.input',
      options: getRiskOptions(
        riskList,
        Constants.RISK_TYPE_CONTAINER_INSPECTION_CODE,
        envAttributes['containerInspection']
      )
    });
  }
  if (filter === null || filter === 'pipingInspection') {
    environmentalInformationSelectInputProps.push({
      propertyName: 'pipingInspection',
      label: 'inventory.details.page.environmental.inf.container.piping.inspection.input',
      options: getRiskOptions(
        riskList,
        Constants.RISK_TYPE_PIPING_INSPECTION_CODE,
        envAttributes['pipingInspection']
      )
    });
  }
  if (filter === null || filter === 'procLoadUnload') {
    environmentalInformationSelectInputProps.push({
      propertyName: 'procLoadUnload',
      label: 'inventory.details.page.environmental.inf.container.proc.load.unload.input',
      options: getRiskOptions(
        riskList,
        Constants.RISK_TYPE_PROC_LOAD_UNLOAD_CODE,
        envAttributes['procLoadUnload']
      )
    });
  }
  if (filter === null || filter === 'adequacyReten') {
    environmentalInformationSelectInputProps.push({
      propertyName: 'adequacyReten',
      label: 'inventory.details.page.environmental.inf.container.adequacy.reten.input',
      options: getRiskOptions(
        riskList,
        Constants.RISK_TYPE_ADEQUACY_RETEN_CODE,
        envAttributes['adequacyReten']
      )
    });
  }
  if (filter === null || filter === 'testRetenTightness') {
    environmentalInformationSelectInputProps.push({
      propertyName: 'testRetenTightness',
      label: 'inventory.details.page.environmental.inf.container.test.reten.tightness.input',
      options: getRiskOptions(
        riskList,
        Constants.RISK_TYPE_TEST_RETEN_TIGHTNESS_CODE,
        envAttributes['testRetenTightness']
      )
    });
  }
  if (filter === null || filter === 'leakDetectInspection') {
    environmentalInformationSelectInputProps.push({
      propertyName: 'leakDetectInspection',
      label: 'inventory.details.page.environmental.inf.container.leak.detect.inspection.input',
      options: getRiskOptions(
        riskList,
        Constants.RISK_TYPE_LEAK_DETECT_INSPECTION_CODE,
        envAttributes['leakDetectInspection']
      )
    });
  }
  if (filter === null || filter === 'overflowDetectInspection') {
    environmentalInformationSelectInputProps.push({
      propertyName: 'overflowDetectInspection',
      label: 'inventory.details.page.environmental.inf.container.overflow.detect.inspection.input',
      options: getRiskOptions(
        riskList,
        Constants.RISK_TYPE_OVERFLOW_DETECT_INSPECTION_CODE,
        envAttributes['overflowDetectInspection']
      )
    });
  }
  if (filter === null || filter === 'adequacySeparBufTank') {
    environmentalInformationSelectInputProps.push({
      propertyName: 'adequacySeparBufTank',
      label: 'inventory.details.page.environmental.inf.container.adequacy.separ.buf.tank.input',
      options: getRiskOptions(
        riskList,
        Constants.RISK_TYPE_ADEQUACY_SEPAR_BUF_TANK_CODE,
        envAttributes['adequacySeparBufTank']
      )
    });
  }
  if (filter === null || filter === 'separBufTankInspection') {
    environmentalInformationSelectInputProps.push({
      propertyName: 'separBufTankInspection',
      label: 'inventory.details.page.environmental.inf.container.separ.buf.tank.inspection.input',
      options: getRiskOptions(
        riskList,
        Constants.RISK_TYPE_SEPAR_BUF_TANK_INSPECTION_CODE,
        envAttributes['separBufTankInspection']
      )
    });
  }
  if (filter === null || filter === 'spillKit') {
    environmentalInformationSelectInputProps.push({
      propertyName: 'spillKit',
      label: 'inventory.details.page.environmental.inf.container.spill.kit.input',
      options: getRiskOptions(
        riskList,
        Constants.RISK_TYPE_SPILL_KIT_CODE,
        envAttributes['spillKit']
      )
    });
  }

  return environmentalInformationSelectInputProps;
};
